import axios from 'axios';
import authHeaders from '../services/auth-header';

const PATIENTS_URL = process.env.VUE_APP_BASE_AP_URL+`/patients`;

export async function getPatientDetails(patientId) {
	return axios.get(`${PATIENTS_URL}/${patientId}/details`,  { headers: { 'Authorization':authHeaders()}})
	.then(response => {
      if(response.data) {
          return Promise.resolve(response.data)
      }
	})
	.catch(function (error) {
      return Promise.reject(error.reponse)
	});
}
